/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatRtfIcon16Light } from './FileFormatRtfIcon16Light';
import { FileFormatRtfIcon16Regular } from './FileFormatRtfIcon16Regular';
import { FileFormatRtfIcon16Solid } from './FileFormatRtfIcon16Solid';
import { FileFormatRtfIcon20Light } from './FileFormatRtfIcon20Light';
import { FileFormatRtfIcon20Regular } from './FileFormatRtfIcon20Regular';
import { FileFormatRtfIcon20Solid } from './FileFormatRtfIcon20Solid';
import { FileFormatRtfIcon24Regular } from './FileFormatRtfIcon24Regular';
import { FileFormatRtfIcon24Solid } from './FileFormatRtfIcon24Solid';
import { FileFormatRtfIcon32Regular } from './FileFormatRtfIcon32Regular';
import { FileFormatRtfIcon64Regular } from './FileFormatRtfIcon64Regular';
var sizes = {
    16: {
        light: FileFormatRtfIcon16Light,
        regular: FileFormatRtfIcon16Regular,
        solid: FileFormatRtfIcon16Solid,
    },
    20: {
        light: FileFormatRtfIcon20Light,
        regular: FileFormatRtfIcon20Regular,
        solid: FileFormatRtfIcon20Solid,
    },
    24: {
        regular: FileFormatRtfIcon24Regular,
        solid: FileFormatRtfIcon24Solid,
    },
    32: {
        regular: FileFormatRtfIcon32Regular,
    },
    64: {
        regular: FileFormatRtfIcon64Regular,
    },
};
export var FileFormatRtfIcon = forwardRef('FileFormatRtfIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
